<!--Field type one start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_1">
    <div class="form-row {{ field.extraClass }}">
        <mat-form-field
            #dateFieldRef
            [appearance]="'outline'"
            [color]="'accent'"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
        >
            <mat-label>{{ field.label }}</mat-label>
            <input
                matInput
                (click)="picker.open()"
                [min]="
                    field.minDate
                        ? field.minDate
                        : field.groupByKey
                        ? field.minDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.minDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.minDateFromControl).value
                            : null
                        : field.minDateFromControl &&
                          formGroup.get(field.minDateFromControl)
                        ? formGroup.get(field.minDateFromControl).value
                        : null
                "
                [max]="
                    field.maxDate
                        ? field.maxDate
                        : field.groupByKey
                        ? field.maxDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.maxDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.maxDateFromControl).value
                            : null
                        : field.maxDateFromControl &&
                          formGroup.get(field.maxDateFromControl)
                        ? formGroup.get(field.maxDateFromControl).value
                        : null
                "
                [matDatepicker]="picker"
                [class.disabled]="
                    formGeneratorInput.state === FormState.IDLE ||
                    field.disabled
                "
                [required]="field.required"
                [name]="field.name"
                (focus)="
                    field.prefixIcon ? dateFieldRef.updateOutlineGap() : ''
                "
                (focusout)="
                    field.onFocusout
                        ? field.onFocusout($event, formGroup, field.name)
                        : null
                "
                [formControl]="control"
                [errorStateMatcher]="matcher"
            />

            <mat-datepicker-toggle
                matSuffix
                [for]="picker"
            ></mat-datepicker-toggle>

            <mat-datepicker #picker></mat-datepicker>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
            <mat-icon
                *ngIf="field.suffixIcon"
                matSuffix
                [matTooltip]="field.suffixIcon.hoverText"
                class="clickable"
                (click)="
                    field.suffixIcon.function
                        ? field.suffixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.suffixIcon.iconData.class }}
            </mat-icon>
            <!-- Handling errors -->
            <ng-container *ngIf="!field.groupByKey">
                <ng-template *ngTemplateOutlet="error"></ng-template>
            </ng-container>
            <ng-container *ngIf="field.groupByKey">
                <ng-template *ngTemplateOutlet="groupError"></ng-template>
            </ng-container>
        </mat-form-field>
    </div>
</ng-container>
<!--Field type one end -->

<!--Field type two start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_2">
    <div class="form-row {{ field.extraClass }}">
        <mat-form-field
            #dateFieldRef
            [appearance]="'outline'"
            [color]="'accent'"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
        >
            <input
                matInput
                (click)="picker.open()"
                [min]="
                    field.minDate
                        ? field.minDate
                        : field.groupByKey
                        ? field.minDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.minDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.minDateFromControl).value
                            : null
                        : field.minDateFromControl &&
                          formGroup.get(field.minDateFromControl)
                        ? formGroup.get(field.minDateFromControl).value
                        : null
                "
                [max]="
                    field.maxDate
                        ? field.maxDate
                        : field.groupByKey
                        ? field.maxDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.maxDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.maxDateFromControl).value
                            : null
                        : field.maxDateFromControl &&
                          formGroup.get(field.maxDateFromControl)
                        ? formGroup.get(field.maxDateFromControl).value
                        : null
                "
                [matDatepicker]="picker"
                [class.disabled]="
                    formGeneratorInput.state === FormState.IDLE ||
                    field.disabled
                "
                [required]="field.required"
                [name]="field.name"
                (focus)="
                    field.prefixIcon ? dateFieldRef.updateOutlineGap() : ''
                "
                (focusout)="
                    field.onFocusout
                        ? field.onFocusout($event, formGroup, field.name)
                        : null
                "
                [formControl]="control"
                [errorStateMatcher]="matcher"
            />

            <mat-datepicker-toggle
                matSuffix
                [for]="picker"
            ></mat-datepicker-toggle>

            <mat-datepicker #picker></mat-datepicker>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
            <mat-icon
                *ngIf="field.suffixIcon"
                matSuffix
                [matTooltip]="field.suffixIcon.hoverText"
                class="clickable"
                (click)="
                    field.suffixIcon.function
                        ? field.suffixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.suffixIcon.iconData.class }}
            </mat-icon>
            <!-- Handling errors -->
            <ng-container *ngIf="!field.groupByKey">
                <ng-template *ngTemplateOutlet="error"></ng-template>
            </ng-container>
            <ng-container *ngIf="field.groupByKey">
                <ng-template *ngTemplateOutlet="groupError"></ng-template>
            </ng-container>
        </mat-form-field>
    </div>
</ng-container>
<!--Field type two end -->

<!--Field type three start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_3">
    <div class="form-row {{ field.extraClass }}">
        <span class="form-label">
            {{ field.label }}
            <span *ngIf="field.required" class="color-warn"> &nbsp;* </span>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
        </span>
        <mat-form-field
            #dateFieldRef
            class="form-input"
            [appearance]="'legacy'"
            [color]="'accent'"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
        >
            <input
                matInput
                (click)="picker.open()"
                [min]="
                    field.minDate
                        ? field.minDate
                        : field.groupByKey
                        ? field.minDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.minDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.minDateFromControl).value
                            : null
                        : field.minDateFromControl &&
                          formGroup.get(field.minDateFromControl)
                        ? formGroup.get(field.minDateFromControl).value
                        : null
                "
                [max]="
                    field.maxDate
                        ? field.maxDate
                        : field.groupByKey
                        ? field.maxDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.maxDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.maxDateFromControl).value
                            : null
                        : field.maxDateFromControl &&
                          formGroup.get(field.maxDateFromControl)
                        ? formGroup.get(field.maxDateFromControl).value
                        : null
                "
                [matDatepicker]="picker"
                [class.disabled]="
                    formGeneratorInput.state === FormState.IDLE ||
                    field.disabled
                "
                [required]="field.required"
                [name]="field.name"
                (focus)="
                    field.prefixIcon ? dateFieldRef.updateOutlineGap() : ''
                "
                (focusout)="
                    field.onFocusout
                        ? field.onFocusout($event, formGroup, field.name)
                        : null
                "
                [formControl]="control"
                [errorStateMatcher]="matcher"
            />

            <mat-datepicker-toggle
                matSuffix
                [for]="picker"
            ></mat-datepicker-toggle>

            <mat-datepicker #picker></mat-datepicker>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
            <mat-icon
                *ngIf="field.suffixIcon"
                matSuffix
                [matTooltip]="field.suffixIcon.hoverText"
                class="clickable"
                (click)="
                    field.suffixIcon.function
                        ? field.suffixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.suffixIcon.iconData.class }}
            </mat-icon>
            <!-- Handling errors -->
            <ng-container *ngIf="!field.groupByKey">
                <ng-template *ngTemplateOutlet="error"></ng-template>
            </ng-container>
            <ng-container *ngIf="field.groupByKey">
                <ng-template *ngTemplateOutlet="groupError"></ng-template>
            </ng-container>
        </mat-form-field>
    </div>
</ng-container>
<!--Field type three end -->

<!--Field type four start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_4">
    <div class="form-row {{ field.extraClass }}">
        <mat-form-field
            #dateFieldRef
            [appearance]="'legacy'"
            [color]="'accent'"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
        >
            <input
                matInput
                (click)="picker.open()"
                [min]="
                    field.minDate
                        ? field.minDate
                        : field.groupByKey
                        ? field.minDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.minDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.minDateFromControl).value
                            : null
                        : field.minDateFromControl &&
                          formGroup.get(field.minDateFromControl)
                        ? formGroup.get(field.minDateFromControl).value
                        : null
                "
                [max]="
                    field.maxDate
                        ? field.maxDate
                        : field.groupByKey
                        ? field.maxDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.maxDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.maxDateFromControl).value
                            : null
                        : field.maxDateFromControl &&
                          formGroup.get(field.maxDateFromControl)
                        ? formGroup.get(field.maxDateFromControl).value
                        : null
                "
                [matDatepicker]="picker"
                [class.disabled]="
                    formGeneratorInput.state === FormState.IDLE ||
                    field.disabled
                "
                [required]="field.required"
                [name]="field.name"
                (focus)="
                    field.prefixIcon ? dateFieldRef.updateOutlineGap() : ''
                "
                (focusout)="
                    field.onFocusout
                        ? field.onFocusout($event, formGroup, field.name)
                        : null
                "
                [formControl]="control"
                [errorStateMatcher]="matcher"
            />

            <mat-datepicker-toggle
                matSuffix
                [for]="picker"
            ></mat-datepicker-toggle>

            <mat-datepicker #picker></mat-datepicker>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
            <mat-icon
                *ngIf="field.suffixIcon"
                matSuffix
                [matTooltip]="field.suffixIcon.hoverText"
                class="clickable"
                (click)="
                    field.suffixIcon.function
                        ? field.suffixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.suffixIcon.iconData.class }}
            </mat-icon>
            <!-- Handling errors -->
            <ng-container *ngIf="!field.groupByKey">
                <ng-template *ngTemplateOutlet="error"></ng-template>
            </ng-container>
            <ng-container *ngIf="field.groupByKey">
                <ng-template *ngTemplateOutlet="groupError"></ng-template>
            </ng-container>
        </mat-form-field>
    </div>
</ng-container>
<!--Field type four end -->
<!--Field type five start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_5">
    <div class="form-row {{ field.extraClass }} type-5">
        <span class="form-label">
            {{ field.label }}
            <span *ngIf="field.required" class="color-warn"> &nbsp;* </span>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
        </span>
        <mat-form-field
            #dateFieldRef
            class="form-input"
            [appearance]="'legacy'"
            [color]="'accent'"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
        >
            <input
                matInput
                type="text"
                placeholder="MM/DD/YYYY"
                (click)="picker.open()"
                [min]="
                    field.minDate
                        ? field.minDate
                        : field.groupByKey
                        ? field.minDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.minDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.minDateFromControl).value
                            : null
                        : field.minDateFromControl &&
                          formGroup.get(field.minDateFromControl)
                        ? formGroup.get(field.minDateFromControl).value
                        : null
                "
                [max]="
                    field.maxDate
                        ? field.maxDate
                        : field.groupByKey
                        ? field.maxDateFromControl &&
                          formGroup
                              .get(field.groupByKey)
                              .get(field.maxDateFromControl)
                            ? formGroup
                                  .get(field.groupByKey)
                                  .get(field.maxDateFromControl).value
                            : null
                        : field.maxDateFromControl &&
                          formGroup.get(field.maxDateFromControl)
                        ? formGroup.get(field.maxDateFromControl).value
                        : null
                "
                [matDatepicker]="picker"
                [class.disabled]="
                    formGeneratorInput.state === FormState.IDLE ||
                    field.disabled
                "
                [required]="field.required"
                [name]="field.name"
                (focus)="
                    field.prefixIcon ? dateFieldRef.updateOutlineGap() : ''
                "
                (focusout)="
                    field.onFocusout
                        ? field.onFocusout($event, formGroup, field.name)
                        : null
                "
                [formControl]="control"
                [errorStateMatcher]="matcher"
            />
            <mat-datepicker-toggle
                matSuffix
                [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
            <mat-icon
                *ngIf="field.suffixIcon"
                matSuffix
                [matTooltip]="field.suffixIcon.hoverText"
                class="clickable"
                (click)="
                    field.suffixIcon.function
                        ? field.suffixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.suffixIcon.iconData.class }}
            </mat-icon>
            <!-- Handling errors -->
            <ng-container *ngIf="!field.groupByKey">
                <ng-template *ngTemplateOutlet="error"></ng-template>
            </ng-container>
            <ng-container *ngIf="field.groupByKey">
                <ng-template *ngTemplateOutlet="groupError"></ng-template>
            </ng-container>
        </mat-form-field>
    </div>
</ng-container>
<!--Field type five end -->
<!-- Error Templates -->
<ng-template #groupError>
    <ng-container
        *ngIf="
            formGroup.get(field.groupByKey).get(field.name).touched &&
            formGroup.get(field.groupByKey).get(field.name).errors
        "
    >
        <mat-error>
            {{
                field.validations
                    | formErrorValidation
                        : formGroup.get(field.groupByKey).get(field.name).errors
            }}
        </mat-error>
    </ng-container>
</ng-template>
<ng-template #error>
    <ng-container
        *ngIf="
            formGroup.get(field.name).touched &&
            formGroup.get(field.name).errors
        "
    >
        <mat-error>
            {{
                field.validations
                    | formErrorValidation : formGroup.get(field.name).errors
            }}
        </mat-error>
    </ng-container>
</ng-template>
